"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFromPesel = void 0;
var padNumber_1 = require("./padNumber");
function dateFromPesel(pesel) {
    if (typeof pesel !== 'string' || pesel.length < 6) {
        return '';
    }
    // let month = parseInt(pesel.substring(2, 4), 10);
    var month = +pesel[2] * 10 + +pesel[3];
    // const day = parseInt(pesel.substring(4, 6), 10);
    var day = +pesel[4] * 10 + +pesel[5];
    if (month && day) {
        // let year = parseInt(pesel.substring(0, 2), 10);
        var year = +pesel[0] * 10 + +pesel[1] + 1900;
        if (month > 80) {
            year -= 100;
            month -= 80;
        }
        else {
            while (month > 20) {
                year += 100;
                month -= 20;
            }
        }
        return year + '-' + (0, padNumber_1.default)(month) + '-' + (0, padNumber_1.default)(day);
    }
    return '';
}
exports.dateFromPesel = dateFromPesel;
exports.default = dateFromPesel;
//# sourceMappingURL=dateFromPesel.js.map